import React, { useEffect } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import './global.css';

import MainPage from "./pages/MainPage";
import AdminDashboardV2 from "./pages/AdminDashboardV2";
import LoginPage from "./pages/LoginPage";
import EpubReader from "./components/EpubReader";
import Store from "./pages/Store";
import PrivateRoute from "./components/PrivateRoute";
import Cart from './components/Cart';
import CartButton from './components/CartButton';
import { CartProvider } from './context/CartContext';
import BackToTop from './components/BackToTop';


function App() {
  // --- Move applyTheme above useEffect
  const applyTheme = (themeName) => {
    // Fade out
    document.body.classList.add('theme-switching');

    setTimeout(() => {
      // Clear and apply new theme
      document.body.className = '';
      if (themeName !== 'default') {
        document.body.classList.add(themeName);
      }
      // Fade back in
      setTimeout(() => {
        document.body.classList.remove('theme-switching');
      }, 50);
    }, 150);
  };

  useEffect(() => {
    const savedTheme = localStorage.getItem('theme') || 'default';
    applyTheme(savedTheme);
  }, []);

  const changeTheme = (e) => {
    const themeName = e.target.value;
    localStorage.setItem('theme', themeName);
    applyTheme(themeName);
  };

  return (
    <CartProvider>
      <>
        {/* Theme selector */}
        <select
          onChange={changeTheme}
          defaultValue={localStorage.getItem('theme') || 'default'}
          className="theme-switcher"
        >
         // <option value="default">Default (Black/Red)</option>
          <option value="obsidian-core">obsidian-core - $79</option>
          <option value="nightfall-indigo">nightfall-indigo - $49</option>
          <option value="carbon-pulse">carbon-pulse - $49</option>
          <option value="shadow-ember">shadow-ember - $69</option>
          <option value="astral-void">astral-void - $79</option>
          <option value="blackwater-depths">blackwater-depths - $79</option>
          <option value="grimlight">grimlight - $79</option>
          <option value="phantom-rose">phantom-rose - $79</option>
          <option value="dark-aurora">dark-aurora - $79</option>
          <option value="terminal-ghost">terminal-ghost - $79</option>
          <option value="steel-horizon">steel-horizon - $89</option>
          <option value="copper-ember">copper-ember - $89</option>
          <option value="gunmetal-alloy">gunmetal-alloy - $89</option>
          <option value="gold-royale">gold-royale - $129</option>
          <option value="bronze-forge">bronze-forge - $89</option>
          <option value="ironclad">ironclad - $99</option>
          <option value="neon-magenta">neon-magenta - $69</option>
          <option value="cyber-lime">cyber-lime - $69</option>
          <option value="vaporwave-sunset">vaporwave-sunset - $79</option>
          <option value="arcade-blue">arcade-blue - $69</option>
          <option value="laser-grid">laser-grid - $79</option>
          <option value="synthwave-horizon">synthwave-horizon - $79</option>
          <option value="neon-orchid">neon-orchid - $69</option>
          <option value="electric-aqua">electric-aqua - $69</option>
          <option value="hypernova">hypernova - $89</option>
          <option value="circuit-breaker">circuit-breaker - $69</option>
        </select>

        {/* Main components */}

        <Cart />
        <CartButton />
 <BackToTop />



        {/* Routes */}
        <Routes>
          <Route path="/" element={<MainPage />} />
          <Route path="/login" element={<LoginPage />} />
          <Route
            path="/admin/dashboard"
            element={
              <PrivateRoute>
                <AdminDashboardV2 />
              </PrivateRoute>
            }
          />
          <Route path="/reader" element={<EpubReader />} />
          <Route path="/store" element={<Store />} />
          <Route path="*" element={<Navigate to="/" />} />
        </Routes>
      </>
    </CartProvider>



  );
}

export default App;